import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";
import { BN, Provider } from "@coral-xyz/anchor";

/**
 * Minting DST tokens is as follows:
 *
 * 1. Create a MintTo instruction
 * 2. Send the transaction
 *
 * @param provider
 */
export function mintDST({
  dst,
  dstTokenAccount,
  mintAmount,
  sourceVsolAccount,
  owner,
  provider,
}: {
  dst: PublicKey;
  dstTokenAccount: PublicKey;
  mintAmount: number;
  sourceVsolAccount: PublicKey;
  owner: PublicKey;
  provider?: Provider;
}) {
  const program = makeDSTProgram(provider);
  const result = program.methods.mintDst(new BN(mintAmount)).accounts({
    dst,
    sourceVsolAccount,
    owner,
    dstTokenAccount,
  });

  return result;
}
